export const EVENTS = {
  TICKETS: {
    FILTERS_OPEN: 'tickets.filters.open',
    FILTERS_APPLY: 'tickets.filters.apply',
    FILTERS_RESET: 'tickets.filters.reset',
    SEARCH_OPEN: 'tickets.search.open',
    SEARCH_APPLY: 'tickets.search.apply',
    FAVORITES_TOGGLE: 'tickets.favorites.toggle',
    CATEGORY_SELECT: 'tickets.category.select',
  }
};
